var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconMyFlagsHighlight2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26.857,
    height: 23.071,
    viewBox: "0 0 26.857 23.071",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_521",
    "data-name": "Group 521",
    transform: "translate(-2402.643 -986.428)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_193",
    "data-name": "Group 193",
    transform: "translate(382.76 297.142)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_225",
    "data-name": "Path 225",
    d: "M2035.279,693.86v-2.171a1.992,1.992,0,0,0-2.069-1.9h-10.758a1.992,1.992,0,0,0-2.069,1.9v20.168l7.448-6.85,7.448,6.85v-7",
    fill: "none",
    stroke: "#E31690",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_226",
    "data-name": "Path 226",
    d: "M2038.883,705.36",
    fill: "none",
    stroke: "#E31690",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_192",
    "data-name": "Group 192",
    transform: "translate(2804.393 1791.14) rotate(180)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_145",
    "data-name": "Group 145",
    transform: "translate(371.393 792.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_144",
    "data-name": "Group 144",
    transform: "translate(0 4.85)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_135",
    "data-name": "Path 135",
    d: "M2783.031,1597.35a4.814,4.814,0,0,1-3.575,1.589c-3.575,0-3.575-3.178-7.151-3.178s-3.576,3.178-7.152,3.178c-1.877,0-2.769-.876-3.947-1.915",
    transform: "translate(-2757 -1596.761)",
    fill: "none",
    stroke: "#E31690",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_227",
    "data-name": "Path 227",
    d: "M2783.031,1597.35a4.814,4.814,0,0,1-3.575,1.589c-3.575,0-3.575-3.178-7.151-3.178s-3.576,3.178-7.152,3.178c-1.877,0-2.769-.876-3.947-1.915",
    transform: "translate(-2757 -1600.761)",
    fill: "none",
    stroke: "#E31690",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMyFlagsHighlight2);
export default __webpack_public_path__ + "static/media/icon-my-flags-highlight-2.64653a10.svg";
export { ForwardRef as ReactComponent };